import { createSlice } from "@reduxjs/toolkit";

const sessionId = createSlice({
  name: "sessionId",
  initialState: "",
  reducers: {
    saveSessionId: (state, action) => action.payload,
  },
});

export default sessionId;
